export enum ErrorCodes {
  BadRequest = '400',
  NotFound = '404',
  AccessDenied = '401',
  Forbidden = '403',
}

export const RESPONSE_CODE = {
  NO_CONTENT: 204,
} as const;
